"use strict";

var _regeneratorRuntime = require("/home/circleci/project/packages/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // some imports must use wildcard for it to work with rollupjs

var _privToAddress = __importStar(require("ethereum-private-key-to-address"));

var ethers = __importStar(require("ethers"));

var to_hex_1 = __importDefault(require("to-hex"));

var uuidlib = __importStar(require("uuidv4"));

var querystring_1 = __importDefault(require("querystring"));

var bn_js_1 = __importDefault(require("bn.js"));

var uuid = uuidlib.uuid;
exports.uuidv4 = uuid;
exports.privateKeyToAddress = _privToAddress;

exports.wait = function (t) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve) {
              return setTimeout(function () {
                return resolve();
              }, t);
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

exports.toHex = function (value) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (opts.addPrefix === undefined) {
    opts.addPrefix = true;
  }

  opts.default = 0;
  return to_hex_1.default(value, opts);
};

exports.signWithPrivateKey = function (message, privateKey, providerUri) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var provider, wallet, data, signature, address;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (privateKey) {
              _context2.next = 2;
              break;
            }

            throw new Error('private key is required');

          case 2:
            provider = new ethers.providers.JsonRpcProvider(providerUri);
            wallet = new ethers.Wallet(privateKey, provider);
            data = message;

            if (message.startsWith('0x')) {
              data = ethers.utils.arrayify(message);
            }

            _context2.next = 8;
            return wallet.signMessage(data);

          case 8:
            signature = _context2.sent;
            address = exports.privateKeyToAddress(privateKey);
            /*
            const verified = verifySignature(message, signature, address)
               if (!verified) {
              throw new Error('signature produced is invalid')
            }
             */

            return _context2.abrupt("return", signature);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};

exports.debounce = function (callback, time) {
  var interval;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(interval);
    interval = setTimeout(function () {
      interval = null;
      callback.apply(void 0, args);
    }, time);
  };
};

exports.throttle = function (fn, interval) {
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var queue = new Map();
  var currentTick = 0;
  var activeCount = 0;

  var throttled = function throttled() {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var timeout;
    return new Promise(function (resolve, reject) {
      var execute = function execute() {
        resolve(fn.apply(_this, args));
        queue.delete(timeout);
      };

      var now = Date.now();

      if (now - currentTick > interval) {
        activeCount = 1;
        currentTick = now;
        timeout = setTimeout(execute, currentTick - now);
      } else if (activeCount < limit) {
        activeCount++;
      } else {
        activeCount = 1;
      }

      queue.set(timeout, reject);
    });
  };

  return throttled;
};

exports.getQueryParamValue = function (name) {
  var query = window.location.search.substr(1);
  var params = querystring_1.default.parse(query);

  if (params[name]) {
    return params[name];
  }

  return null;
};

exports.removeQueryParam = function (key) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;

  try {
    var u = new URL(url);

    if ('URLSearchParams' in window) {
      var searchParams = new URLSearchParams(u.search);
      searchParams.delete(key);
      u.search = searchParams.toString();
      return u.toString();
    }
  } catch (err) {// noop
  }

  return url;
};

exports.updateQueryParams = function () {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;

  try {
    var u = new URL(url);

    if ('URLSearchParams' in window) {
      var searchParams = new URLSearchParams(u.search);

      for (var key in params) {
        var value = params[key];

        if (!value) {
          continue;
        }

        searchParams.set(key, value);
      }

      u.search = searchParams.toString();
      return u.toString();
    }
  } catch (err) {// noop
  }

  return url;
};

exports.replaceWindowUrl = function (newUrl) {
  try {
    window.history.replaceState({}, document.title, newUrl);
  } catch (err) {// noop
  }
};

exports.browserInfo = function () {
  var ret;
  var tmp;
  var ua = navigator.userAgent;
  var m = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

  if (/trident/i.test(m[1])) {
    tmp = /\brv[ :]+(\d+)/g.exec(ua) || [];
    ret = 'IE ' + (tmp[1] || '');
  }

  if (m[1] === 'Chrome') {
    tmp = ua.match(/\b(OPR|Edge?)\/(\d+)/);

    if (tmp != null) {
      ret = tmp.slice(1).join(' ').replace('OPR', 'Opera').replace('Edg ', 'Edge ');
    }
  }

  m = m[2] ? [m[1], m[2]] : [navigator.appName, navigator.appVersion, '-?'];
  var v = (tmp = ua.match(/version\/(\d+)/i)) != null;

  if (v) {
    m.splice(1, 1, tmp[1]);
  }

  ret = m.join(' ');
  var p = ret.split(' ');
  return {
    browser: p[0],
    version: p[1]
  };
};

exports.exportRecoveryParam = function (recoveryParam) {
  return typeof recoveryParam === 'number' ? new bn_js_1.default(recoveryParam).add(new bn_js_1.default(27)).toString(16) : null;
};

exports.importRecoveryParam = function (v) {
  return v.trim() ? new bn_js_1.default(v, 16).sub(new bn_js_1.default(27)).toNumber() : undefined;
};